import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';

import '../lib/SplitText';

export default el => {
    const dom = $(el);

    const footer = dom.find('[data-footer]').get(0);
    const split = new SplitText(dom.find('[data-text]').nodes, {type: 'lines'});
    const items = split.lines;

    const init = () => {
        let delay = 0.2;
        items.forEach(node => {
            node.setAttribute('data-reveal', delay);
            delay += 0.1;
        });

        footer.setAttribute('data-reveal', delay);
    };

    const destroy = () => {

    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Quote.js